<script>
  export default {
    components: { 
      alert, 
    },
    props: {
      titleCard: String,
      texto: String,
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {

    },
    computed: {

    }
  }
</script>

<template>
    <div class="col-lg-12">
        <div class="ibox ">
            <div class="ibox-title">
                <i class="fa fa-exclamation-triangle" aria-hidden="true" style="color: #ff00008a;float: left;font-size: 16px;margin-right: 10px;"></i>
                <h5 class="MuiTypography-h6">{{titleCard}}</h5>
            </div>
            <div class="ibox-content" style="padding: 0px 15px 15px;">
                <div class="feed-activity-list">

                    <div class="TextoListagem" style="margin-top: 12px;" v-html="configuracao.mensagemAvisoGeral" />
                  
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
   .MuiTypography-h6 {
        font-size: 1.7rem;
        font-family: 'Maven Pro', sans-serif;
        font-weight: 550;
  } 

  .TextoListagem {
        font-size: 16px;
        font-family: 'Maven Pro', sans-serif;
  } 

  .TextoQuantidades {
        font-size: 13px;
  } 
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/notificacoes/componentes/CardAviso.vue